import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import classNames from 'classnames';
import { Col, ControlLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { titles } from './constants';
import styles from './FullName.module.css';
import AutoDirectors from './limitedCompany/AutoDirectors';
import Name from './Name';
import {
    fixUserCapitalisationErrors,
    onlyLettersAndSpacesAndDashes
} from '../../helpers/helpers';
import normalizer from '../../helpers/inputNormalizer';
import Select from '../FormField/Select';

function FullName({ person, enableDirectorSearch }) {
    const onTitleSelect = (title) => {
        tracking.ampli.formFieldCompleted({
            form_field: 'full_name_title'
        });
        let val = (title && title.value) || '';
        person.title.onChange(val);
    };

    const title = person.title;
    const firstName = normalizer(
        person.first_name,
        onlyLettersAndSpacesAndDashes,
        fixUserCapitalisationErrors
    );
    const lastName = normalizer(
        person.last_name,
        onlyLettersAndSpacesAndDashes,
        fixUserCapitalisationErrors
    );

    const fields = [title, firstName, lastName];
    const hasAnyErrorFields = fields.some(
        (field) => field.touched && field.error
    );

    return (
        <Col
            xs={12}
            sm={6}
            className={classNames({ invalid: hasAnyErrorFields })}>
            <ControlLabel>Full name</ControlLabel>

            <div className="multi-error-container">
                {fields
                    .filter((field) => field.error)
                    .map((field) => (
                        <div
                            key={field.name}
                            data-testid={`${field.name}-error`}
                            className="error multi-error">
                            <FormattedMessage
                                id={field.error}
                                defaultMessage={field.error}
                            />
                        </div>
                    ))}
            </div>

            <Col
                key={title.name}
                xs={3}
                className={classNames('no-pad title fs-exclude', styles.title)}>
                <Select
                    placeholder="Title"
                    value={title.value}
                    onChange={onTitleSelect}
                    options={titles}
                />
            </Col>

            {enableDirectorSearch ? (
                <Col xs={9} className="no-pad fs-exclude">
                    <AutoDirectors
                        firstNameField={firstName}
                        lastNameField={lastName}
                    />
                </Col>
            ) : (
                <Name firstNameField={firstName} lastNameField={lastName} />
            )}
        </Col>
    );
}

export default FullName;
